import React, { useEffect, useState } from "react";
import { SearchOutlined } from "@ant-design/icons";
import { Table, Select, Input, message, DatePicker, Col, Row, Spin } from "antd";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import moment from "moment";
import { getClientid, getUserInfo, getUserList, } from "redux/selectors";
import { CALL_API } from "common/API";
import { connect } from "react-redux";
import ViewIncidentLog from "./Viewincidentlog";
import styled from "styled-components";
const CustomStyle = styled.div`
 .ant-table {
    border: 1px solid #e2e2e8;
    border-radius: 8px;
  }
  .ant-table-thead > tr > th {
    font-size: 16px;
    font-weight: 500;
    color: #1f243b;
  }
  .ant-table-tbody > tr > td {
    font-size: 15.2px;
    font-weight: 400;
    color: #636980;
  }
  .total {
    display: flex;
    // justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  }

  .in {
    font-size: 16px;
    font-weight: 500;
    color: #333;
  }

  .inci {
    font-weight: 400 !important;
    font-size: 14px !important;
  }

  .action-dropdown .ant-select-selector {
    width: 200px;
    height: 34px;
    border-radius: 24px;
    font-weight: 400;
    font-size: 14px;
    color: #636980;
    margin-left: 0px;
  }

  .search {
    width: 200px;
    height: 34px;
    border-radius: 24px;
    font-weight: 400;
    font-size: 14px;
    color: #636980;
    margin-left: -5px;
  }

  /* Hover effect to change color on hover */
  .dropdown-container a:hover {
    color: #1890ff;
  }

  .dropdown-container a .anticon {
    margin-left: 5px; /* Adjust spacing */
    font-size: 9px; /* Make the arrow smaller */
  }
  .action-icons {
    display: none;
    gap: 16px; /* Hide by default */
  }

  .ant-table-tbody > tr:hover .action-icons {
    display: flex; /* Show only on row hover */
  }
  .custom-row td {
    height: 70px; /* Adjust as needed */
    vertical-align: middle;
  }
  .suspend-text {
    color: #f28916;
  }

  .res-text {
    color: #08c108;
  }
    .adjust-margin {
  margin-top: 10px;
  margin-left:-5px;
}


  .dis-text {
    color: #ee2738;
  }
  .ant-modal {
    z-index: 9999 !important; /* Ensure the modal stays on top */
  }
  .ant-modal-body {
    overflow-y: auto; /* Add this if the modal content overflows */
  }

  .ant-modal-mask {
    background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent mask */
    z-index: 9998; /* Ensure the mask is beneath the modal */
  }
     .date-range-container {
    display: flex;
  
  }
  .datepicker-style {
    width: 180px;
    height: 34px;
    border-radius: 24px;
  }
  
  @media (max-width: 768px) {
    .total {
      display: block !important;
    }
    .search {
      margin-bottom: 10px !important;
      margin-left: 0 !important;
    }
    .action-dropdown {
      margin-bottom: 10px !important;
      margin-left: -12px !important;
    }
  }
`;
function IncidentLog({ userInfo, ClientId, userList }) {
  const [filteredData, setFilteredData] = useState([]); // For search functionality
  const [searchText, setSearchText] = useState("");
  const [showLoader, toggleLoader] = useState(false);
  const history = useHistory();
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [showDateRange, setShowDateRange] = useState(false);
  const [selectedDateRange, setSelectedDateRange] = useState(null);
  const [selectedType, setSelectedType] = useState(null); // Store selected incident type
  const [selectedIncident, setSelectedIncident] = useState(null);
  const [assetsData, setDisData] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const disableToDate = (current) => {
    return fromDate ? current && current.isBefore(fromDate, "day") : false;
  };
  const getDisData = async () => {
    try {
      setLoading(true);
      console.log("Fetching data for user:", userInfo.userid);

      const { data, code } = await CALL_API(
        `incident`,
        "get",
        {}
      );

      if (code === "SUCCESS" && Array.isArray(data)) {
        console.log("Updated Data:", data);
        setDisData([...data].reverse());
        setFilteredData(data);
      } else {
        console.error("Invalid API Response:", data);
        message.error("Failed to fetch data. Please try again.");
      }
    } catch (error) {
      console.error("API Error:", error);
      message.error("Something went wrong while fetching data.");
    } finally {
      setLoading(false);
      toggleLoader(false);
    }
  };

  useEffect(() => {
    getDisData();
  }, []);
  useEffect(() => {
    let filtered = [...assetsData]; // Avoid mutating the original array

    if (searchText) {
      filtered = filtered.filter((incident) =>
        incident?.incidentlocation?.toLowerCase().includes(searchText.toLowerCase())
      );
    }

    if (selectedType) {
      filtered = filtered.filter((incident) =>
        incident?.type?.trim().toLowerCase() === selectedType.toLowerCase()
      );
    }

    if (selectedStatus) {
      filtered = filtered.filter((incident) =>
        incident?.status?.trim().toLowerCase() === selectedStatus.toLowerCase()
      );
    }

    // Date filtering logic
    let startDate, endDate;

    if (selectedDateRange === "Last week") {
      startDate = moment().subtract(1, "weeks").startOf("week");
      endDate = moment().subtract(1, "weeks").endOf("week");
    } else if (selectedDateRange === "Last month") {
      startDate = moment().subtract(1, "months").startOf("month");
      endDate = moment().subtract(1, "months").endOf("month");
    } else if (selectedDateRange === "Last 6 months") {
      startDate = moment().subtract(6, "months").startOf("month");
      endDate = moment().endOf("month");
    } else if (selectedDateRange === "custom" && fromDate && toDate) {
      startDate = moment(fromDate).startOf("day");
      endDate = moment(toDate).endOf("day");
    }

    if (startDate && endDate) {
      filtered = filtered.filter((incident) =>
        moment(incident.date).isBetween(startDate, endDate, null, "[]")
      );
    }

    setFilteredData(filtered);
  }, [searchText, selectedType, selectedStatus, selectedDateRange, fromDate, toDate, assetsData]);

  const handleSelectChange = (value) => {
    setSelectedDateRange(value);
    if (value === "custom") {
      setShowDateRange(true);
    } else {
      setShowDateRange(false);
      setFromDate(null);
      setToDate(null);
    }
  };

  const handleStatusChange = (value) => {
    setSelectedStatus(value);
  };


  const columns = [
    {
      title: "Incident ID",
      dataIndex: "incidentId",
      key: "incidentId",

    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",

    },
    {
      title: "Employee ID",
      dataIndex: "employeeId",
      key: "employeeId",

    },
    {
      title: "Incident Type",
      dataIndex: "type",
      key: "type",

    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: (text) => (text ? moment(text).format("Do MMMM YYYY") : "-"),

    },
    {
      title: "Time",
      dataIndex: "time",
      key: "time",

      render: (text) => (text ? moment(text, "HH:mm").format("hh:mm A") : "-"),

    },


    {
      title: "Location",
      dataIndex: "incidentlocation",
      key: "incidentlocation",
      render: (text) =>
        text
          ? text
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ")
          : "",
    },
    {
      title: "Reported on",
      dataIndex: "updatedAt",
      key: "updatedAt",

      render: (text) => (text ? moment(text).format("Do MMMM YYYY") : "-"),
    },


  ];
  console.log("userlist-->", userList);

  return (
    <CustomStyle>
      <p style={{ fontWeight: 500, fontSize: 20 }}>Incident Log</p>


      <div className="totaldropdowns">
        <Row gutter={16}>
          <Col>
            <div>
              <Input
                className="search"
                placeholder="Search Location"
                prefix={<SearchOutlined />}
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>
          </Col>
          <Col>
            <div className="dropdown-container">
              <Select placeholder="Incident Type" className="action-dropdown" onChange={(value) => setSelectedType(value)}
                allowClear>
                <Select.Option value="Workplace Injury">Workplace Injury</Select.Option>
                <Select.Option value="Hazardous Material Exposure">
                  Hazardous Material Exposure
                </Select.Option>
                <Select.Option value="Vehicle Accident">Vehicle Accident</Select.Option>
                <Select.Option value="Fire or Explosion">Fire or Explosion</Select.Option>
                <Select.Option value="Medical Emergency">Medical Emergency</Select.Option>
                <Select.Option value="Near Miss">Near Miss</Select.Option>
              </Select>
            </div>
          </Col>
          <Col>
            <div className="dropdown-container">
              <Select placeholder="Date" className="action-dropdown" onChange={handleSelectChange}
                allowClear>
                <Select.Option value="Last week">Last week</Select.Option>
                <Select.Option value="Last month">Last month</Select.Option>
                <Select.Option value="Last 6 months">Last 6 months</Select.Option>
                <Select.Option value="custom">Custom Date range</Select.Option>
              </Select>
            </div>
          </Col>
          {showDateRange && ( // Conditionally render the date pickers
            <div className="date-range-container">
              <Col>
                <div>
                  <DatePicker placeholder="From" format="DD-MM-YYYY" className="datepicker-style" onChange={(date) => {
                    setFromDate(date);
                    if (toDate && date && toDate.isBefore(date, "day")) {
                      setToDate(null); // Reset ToDate if it's before the new FromDate
                    }
                  }} />
                </div>
              </Col>
              <Col>
                <div>
                  <DatePicker placeholder="To" format="DD-MM-YYYY" className="datepicker-style" disabledDate={disableToDate} // Disable past dates before FromDate
                    onChange={(date) => setToDate(date)} />
                </div>
              </Col>
            </div>
          )}
          <Col className={`dropdown-container ${showDateRange ? "adjust-margin" : ""}`}>
            <div className="dropdown-container">
              <Select placeholder="Status" className="action-dropdown" onChange={handleStatusChange} allowClear>
                <Select.Option value="Waiting for Review">Waiting for Review</Select.Option>
                <Select.Option value="Under Review">Under Review</Select.Option>
                <Select.Option value="Resolved">Resolved</Select.Option>
                <Select.Option value="Dismissed">Dismissed</Select.Option>
              </Select>
            </div>
          </Col>
        </Row>
      </div>
      <br />
      <p style={{ fontWeight: 400, fontSize: 16 }}>
        Total Incident:
        &nbsp;{filteredData.length}
      </p>
      <Spin spinning={loading} size="medium">
        <Table
          dataSource={filteredData}
          columns={columns}
          pagination={true}
          onRow={(record) => {
            return {
              onClick: () => {
                history.push({
                  pathname: `/viewincidentlog/${record.incidentId}`,  // Navigate to view page
                  state: { incidentData: record }, // Pass the selected row data
                });
              },
            };
          }}
          scroll={{ x: "max-content" }}
          style={{ cursor: "pointer" }}
        />
      </Spin>

    </CustomStyle>

  );
}
const mapStateToProps = (state) => ({
  userInfo: getUserInfo(state),
  ClientId: getClientid(state),
  userList: getUserList(state)
});
export default connect(mapStateToProps)(IncidentLog);
